// SUPP-19669: third-party page scripts (e.g. a customer's GTM container) can
// attach their own `document`-level click listeners that unconditionally
// write an `href` onto whatever `<a>` was clicked, in order to append UTM
// params to outbound links. Several Bizzabo controls render a bare `<a>` as a
// non-link widget (e.g. the registration form's dropdown option rows), so a
// decorator like that turns the option into `<a href="">`, which resolves to
// the current document — the browser then performs a real navigation, fully
// reloading the page and wiping any in-progress form values.
//
// This guard runs on the CAPTURE phase, ahead of any listener registered on
// `document` (those only ever run on bubble), so it inspects the anchor
// before a third-party script gets a chance to touch it. `preventDefault()`
// is a no-op for an anchor that never had a real `href` in the first place,
// and — because the browser's default navigation action only runs after
// event propagation finishes — calling it here still blocks navigation even
// if a decorator writes an `href` on the same click. Any such injected
// `href` — empty or carrying decorator-appended UTM params — is stripped
// afterwards so the anchor's attributes/style are left as they were, and so
// a later click on the same anchor isn't misread as a real link.
const isAnchor = node => node?.tagName === 'A';

let isInstalled = false;

export const installNonLinkAnchorGuard = () => {
    if (typeof document === 'undefined') {
        return;
    }
    if (isInstalled) {
        return;
    }
    isInstalled = true;
    document.addEventListener('click', event => {
        const anchor = event.target?.closest?.('a');
        if (!isAnchor(anchor) || anchor.hasAttribute('href')) {
            return;
        }
        event.preventDefault();
        setTimeout(() => {
            anchor.removeAttribute('href');
        }, 0);
    }, true);
};
